export default () => (
  <svg
    width="60"
    height="60"
    viewBox="0 0 60 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M45.2842 17.5H14.7158C6.63158 17.5 0 24.0684 0 32.2158C0 40.3632 6.63158 46.9316 14.7158 46.9316H45.2842C53.3684 46.9316 60 40.3632 60 32.2158C60 24.0684 53.3684 17.5 45.2842 17.5ZM14.7158 43.0158C8.77895 43.0158 3.91579 38.1526 3.91579 32.2158C3.91579 26.2789 8.77895 21.4158 14.7158 21.4158C20.6526 21.4158 25.5158 26.2789 25.5158 32.2158C25.5158 38.1526 20.6526 43.0158 14.7158 43.0158ZM45.2842 43.0158H24.6947C27.6 40.3 29.4316 36.5105 29.4316 32.2158C29.4316 27.9211 27.6 24.1316 24.6947 21.4158H45.2211C51.1579 21.4158 56.021 26.2789 56.021 32.2158C56.021 38.1526 51.2211 43.0158 45.2842 43.0158Z"
      fill="currentColor"
    />
    <path
      d="M47.8737 26.5347C47.179 25.84 45.9158 25.84 45.2211 26.5347L42.1895 29.5663L39.2211 26.5347C38.5263 25.84 37.2632 25.84 36.5684 26.5347C35.8105 27.2926 35.8105 28.4295 36.5684 29.1874L39.6 32.2189L36.5684 35.2505C35.8105 36.0084 35.8105 37.1453 36.5684 37.9031C36.9474 38.2821 37.3895 38.4716 37.8947 38.4716C38.4 38.4716 38.8421 38.2821 39.2211 37.9031L42.2526 34.8716L45.2842 37.9031C45.6632 38.2821 46.1053 38.4716 46.6105 38.4716C47.1158 38.4716 47.5579 38.2821 47.9368 37.9031C48.6947 37.1453 48.6947 36.0084 47.9368 35.2505L44.9053 32.2189L47.9368 29.1874C48.6316 28.4926 48.6316 27.2926 47.8737 26.5347Z"
      fill="currentColor"
    />
  </svg>
);
